/**
 * =============================================================================
 * theme.js
 * =============================================================================
 * Entry point for all theme Javascript.
 * 
 * Before launching a site, consider what imports you actually need - i.e. which
 * parts of Bootstrap, which vendor JS imports, which Bootstrap plugins, etc.
 * =============================================================================
 */

// Vendor JS, from node_modules
import './vendor.js';

// Project JS
import Stencil from './stencil.js';
window.Stencil = new Stencil();

/**
 * Expose static Stencil methods on the window Stencil instance
 */
Object.getOwnPropertyNames(Stencil)
  .filter(key => typeof Stencil[key] === "function") // Get only static methods
  .forEach(key => window.Stencil[key] = Stencil[key]);

/**
 * Load & define all custom elements in /elements using Webpack custom context
 */
const elementsContext = require.context('./elements', false, /\.js$/);
elementsContext.keys().forEach(file => {
  const moduleName = file.replace('./', '').replace('.js', ''); // Extract name from file
  const module = elementsContext(file);
  customElements.define(moduleName, module.default);
});

/**
 * Register all extensions in /extensions using Webpack custom context
 */
const extensionsContext = require.context('./extensions', false, /\.js$/);
extensionsContext.keys().forEach(file => {
  const moduleName = file.replace('./', '').replace('.js', '').split('-').map(word => word[0].toUpperCase() + word.slice(1).toLowerCase()).join('');
  const module = extensionsContext(file);
  if(module.default.autoregister){
    window.Stencil.registerExtension(new module.default(moduleName));
  }
});

/**
 * Useful global functions
 */
window.debounce = function(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Kickoff!
window.Stencil.init();